import Vue from 'vue/dist/vue.min';
import $ from 'jquery';
window.$ = require('jquery');
import App from './components/App.vue';

new Vue({
    el : '#display-container',
    components : {
        App
    },
    data() {
        return {
            sleep_mode_at: 240,
            sleep_mode : false,
            screensaver: false,
            sleep_mode_timer : null,
            sleep_timer_interval : null,
            touch_here_at : 15,
            touch_msg_interval : null,
            touch_here_mode : false
        }
    },
    mounted() {
        $(document).on('mousemove click keydown', () => {
            clearInterval(this.sleep_timer_interval);
            this.touch_here_mode = false;
            clearInterval(this.touch_msg_interval);
            this.sleepTimer();
            this.touchHereToggle();
        });
    },
    methods : {
        sleepTimer() {
            this.sleep_mode_timer = 0;
            this.sleep_mode = false;
            this.sleep_timer_interval = setInterval(() => {
                if( !this.sleep_mode ) {
                    if( this.sleep_mode_timer < this.sleep_mode_at ) {
                        this.sleep_mode_timer++;
                    } else {
                        this.sleep_mode = true;
                        clearInterval(this.sleep_timer_interval);
                    }
                }
            }, 1000);
        },
        touchHereToggle() {
            let self = this;
            this.touch_msg_interval = setInterval(function () {
                if (!self.sleep_mode) {
                    if (self.sleep_mode_timer > self.touch_here_at) {
                        self.touch_here_mode = true;
                    }
                } else {
                    self.touch_here_mode = false;
                    clearInterval(self.touch_msg_interval);
                }
                self.$emit('touch-here-mode', self.touch_here_mode);
            }, 1500);
        },
        superScript(value) {
            return value.replace(/[™®©]/g, '<sup>$&</sup>');
        }
    }
});

